import * as types from './types';

const setDirtyForm = value => {
  return { type: types.SET_DIRTY_FORM, payload: value };
};

export { setDirtyForm };
